import React from "react";
import localeText from "../../../locale";
import ConfimeaHeader from "./ConfimeaHeader";
import ConfimeaFooter from "./ConfimeaFooter";

const ConfimeaConfirmationLoading = () => {
  return (
    <div className="confimea-confirmation-page">
      <ConfimeaHeader />
      <div className="confimea-confirmation-container">
        <div className="confimea-confirmation-card">
          <div className="text-center">
            <i className="pi pi-spin pi-spinner text-6xl text-500 my-6"></i>
            <p>{localeText("confirmingEmail")}</p>
          </div>
        </div>
      </div>
      <ConfimeaFooter />
    </div>
  );
};

export default ConfimeaConfirmationLoading;

